import { useEffect } from 'react'

interface DescriptionScriptProps {
	productKod: string
	decriptionNode: HTMLDivElement
}

const currentProductKods = [
	'148813',
	'148812',
	'148811',
	'148810',
	'148821',
	'148820',
	'148819',
	'148818',
	'148817',
	'148816',
	'148815',
	'148814',
	'148759',
	'148758',
	'148757',
	'148768',
	'148767',
	'148765',
	'148764',
	'148763',
	'148762',
	'148761',
	'148735',
	'149535',
	'149541',
	'149540',
	'149539',
	'149538',
	'149537',
	'149542',
	'149536',
	'149534',
	'148784',
	'148783',
	'148782',
	'148780',
	'148778',
	'148777',
	'148790',
	'148788',
	'148787',
	'149544',
	'149553',
	'149551',
	'149550',
	'149549',
	'149547',
	'149548',
	'149546',
	'149545',
	'149543',
	'149554',
	'149552',
	'149180',
	'149179',
	'149178',
	'148801',
	'148800',
	'148799',
	'148798',
	'148797',
	'148796',
	'148795',
	'148809',
	'148808',
	'148807',
	'148806',
	'148805',
	'148804',
	'148803',
	'148802',
	'149527'
]

export const DescriptionScript = ({ productKod, decriptionNode }: DescriptionScriptProps) => {
	const initDropdown = () => {
		const dropdown = decriptionNode.querySelector('#upgrader-dropdown')
		const dropdownContents = decriptionNode.querySelectorAll('.dropdown-content')

		if (dropdown) {
			dropdown.addEventListener('change', function (e) {
				// @ts-ignore
				const selectedOption = e.target.options[this.selectedIndex]
				const targetId = selectedOption.getAttribute('data-option-id') + '-upgrader-dropdown'

				dropdownContents.forEach(content => {
					content.classList.remove('active')
				})

				const targetContent = decriptionNode.querySelector(`#${targetId}`)
				if (targetContent) {
					targetContent.classList.add('active')
				}
			})
		}
	}

	// eslint-disable-next-line react-hooks/rules-of-hooks
	useEffect(() => {
		if (!decriptionNode || !currentProductKods.includes(productKod)) return

		initDropdown()
	}, [decriptionNode, productKod])

	return null
}
